import baustein from "baustein";
import analytics from "web/script/analytics/analytics";
import { languageIsEnglish } from "web/script/modules/language";
import store from "web/redux/store";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import "web/script/components/save-for-later-button";
import "web/script/components/save-for-later-signup-prompt";
import "web/script/components/lead-link";
/**
 * OOS Product Layout Info
 *
 * @description this component intends to live in the OOS product layout. Due to the poor state of
 * the Email Capture Prompt component we're making this wrapper component to read Lead clicks
 * within him and fire an stock-alert overlay (with associated analytics) as they happen.
 *
 * @see src/ssaw/portal/templates/layouts/oos_affiliate_product_layout.jinja / oos_icon_product_layout.jinja
 * @see media/web/script/components/email-capture-prompt.js
 */

const CAPTURE_TYPE_STOCK_ALERT_LEAD_RETURN = "stock_alert_lead_return";

export default baustein.register("oos-product-hero", {
    setupEvents(add) {
        if (this.options.productId && this.options.returnUrl) {
            add("show-bis-overlay", this.showCustomerCapture);
            add("click", ".oos-product-hero__button", this.onClickHeroButton);
        }
    },

    onClickHeroButton(event) {
        let el = event.target;
        if (el.nodeName !== "A") {
            el = el.parentElement;
        }
        const reason = el.getAttribute("reason");
        analytics.event("oos-product-hero-button", "click", reason);
    },

    showCustomerCapture() {
        if (!languageIsEnglish()) {
            return;
        }

        store.dispatch(
            openCustomerCaptureOverlay({
                productId: this.options.productId.toString(),
                captureType: CAPTURE_TYPE_STOCK_ALERT_LEAD_RETURN,
            })
        );
    },
});
